import React from 'react';
import { CurrentApplicantContextProvider } from '../shared/contexts/CurrentApplicantContext';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import CourseApplication from './CourseApplication';
import FormInquiry from './FormInquiry';
import { HubspotProvider } from '@aaronhayes/react-use-hubspot-form';
import { PrimeReactProvider } from 'primereact/api';

const App = () => {
  return (
    /* Strict Mode is a tool for highlighting potential problems during development in an application.
     It does not render any visible UI. It activates additional checks and warnings for its descendants. */
    // <React.StrictMode>
    <PrimeReactProvider value={{ ripple: true }}>
      <HubspotProvider>
        <BrowserRouter>
          <Routes>
            <Route
              path='/course-catalog/:curriculum'
              element={<FormInquiry />}
            />
            <Route path='*' element={<CurrentApplicantContextProvider><CourseApplication /></CurrentApplicantContextProvider>} />
          </Routes>
        </BrowserRouter>
      </HubspotProvider>
    </PrimeReactProvider>
    // </React.StrictMode>
  );
};

export default App;
